import { Injectable } from '@angular/core';
import { filter, take } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AllocationViewActionsFacade } from '../allocation-view-actions.facade';
import {
  AllocationActionPrepareCallToDockModel,
  AllocationDetailsModel,
  AllocationManualActionRequestModel,
  AllocationViewSelectedEntityModel,
} from '../../models';
import { AllocationViewActionInterface, AllocationViewCombinedActionInterface } from '../models';

import {
  AllocationViewCallToDockAction,
  AllocationViewCallToDockActionPrepare,
  AllocationViewCallToDockActionAllocateUli,
  AllocationViewCallToDockActionSetInitialState,
} from './allocation-view-call-to-dock-action.actions';
import { AllocationViewCallToDockActionState } from './allocation-view-call-to-dock-action.state';

@Injectable({ providedIn: 'root' })
export class AllocationViewCallToDockActionFacade
  implements AllocationViewActionInterface, AllocationViewCombinedActionInterface
{
  loaded$: Observable<boolean> = this.store.select(AllocationViewCallToDockActionState.getLoaded);

  callToDockDetails$: Observable<AllocationActionPrepareCallToDockModel> = this.store.select(
    AllocationViewCallToDockActionState.getCallToDockDetails,
  );

  allocationDetails$: Observable<AllocationDetailsModel> = this.store.select(
    AllocationViewCallToDockActionState.getAllocationDetails,
  );

  responseData$: Observable<AllocationDetailsModel> = this.store.select(
    AllocationViewCallToDockActionState.getAllocationDetails,
  );

  constructor(private allocationViewActionsFacade: AllocationViewActionsFacade, private store: Store) {}

  loadAll(): void {
    this.allocationViewActionsFacade.actionIdentifier$
      .pipe(filter(Boolean), take(1))
      .subscribe(({ identifier }: AllocationViewSelectedEntityModel) => {
        this.store.dispatch(new AllocationViewCallToDockActionPrepare({ identifier }));
      });
  }

  callToDock(): void {
    this.allocationViewActionsFacade.actionIdentifier$
      .pipe(filter(Boolean), take(1))
      .subscribe(({ identifier }: AllocationViewSelectedEntityModel) => {
        this.store.dispatch(
          new AllocationViewCallToDockAction({
            identifier,
          }),
        );
      });
  }

  allocateUli(data: AllocationManualActionRequestModel): void {
    this.allocationViewActionsFacade.actionIdentifier$.pipe(filter(Boolean), take(1)).subscribe(() => {
      this.store.dispatch(new AllocationViewCallToDockActionAllocateUli(data));
    });
  }

  setInitialState(): void {
    this.store.dispatch(new AllocationViewCallToDockActionSetInitialState());
  }
}
